var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.0347 30.6094C64.0347 51.4108 36.8776 69.2405 36.8776 69.2405C36.8776 69.2405 9.72046 51.4108 9.72046 30.6094C9.72046 23.5163 12.5816 16.7137 17.6746 11.6982C22.7675 6.68259 29.675 3.86487 36.8776 3.86487C44.0801 3.86487 50.9876 6.68259 56.0805 11.6982C61.1735 16.7137 64.0347 23.5163 64.0347 30.6094Z",
    fill: "#496157"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.877 36.5513C40.2099 36.5513 42.9119 33.8904 42.9119 30.608C42.9119 27.3257 40.2099 24.6648 36.877 24.6648C33.544 24.6648 30.842 27.3257 30.842 30.608C30.842 33.8904 33.544 36.5513 36.877 36.5513Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.ff6f2a2b8a10e031293a8c588548d60c.svg";
export { ForwardRef as ReactComponent };